// extracted by mini-css-extract-plugin
export default {"container":"OrdersList_container__y4Q4Q","header":"OrdersList_header__78CPm","orders":"OrdersList_orders__qYEQ0"};